<div class="form-group">
  @if (multiSelection) {
    <span class="form-label" translate>Signals</span>
  }
  @if (!multiSelection) {
    <span class="form-label" translate>Signal</span>
  }
  <ng-select (change)="onSignalSelected($event)"
    [(ngModel)]="selectedSignalsIds"
    [closeOnSelect]="!multiSelection"
    [dropdownPosition]="'top'"
    [items]="items"
    [multiple]="multiSelection"
             [ngClass]="{
                     'is-invalid': validate && !isValid,
                       'is-valid':validate && isValid
                       }"
    [notFoundText]="notFoundLabel"
    [placeholder]="placeholder"

    bindLabel="label"
    bindValue="id">
    @if (multiSelection) {
      <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
        @if (items.length > 0) {
          <div class="ng-value">
            <span class="ng-value-label">
              <strong [innerHTML]="items.length"></strong> &nbsp;
              <span translate>Signal(s) selected</span>
            </span>
          </div>
        }
      </ng-template>
    }
    @if (!multiSelection; as item) {
      <ng-template let-item="item" ng-label-tmp>
        <span [innerHTML]="item.label | translate"></span>
        <span [innerHTML]="getSignalUnit(item)"></span>
      </ng-template>
    }
    <ng-template let-item="item" ng-option-tmp>
      <div class="row">
        <div class="col align-items-center d-flex">
          @if (showColor) {
            <span [style.background-color]="item.signalColor"
            class="color-circle color-circle-xs mr-2"></span>
          }
          <span [innerText]="item.label | translate" class="truncate"></span>
          <span class="ml-1 text-muted">
            <span [innerHTML]="getSignalUnit(item)"></span>
          </span>
          @if (isCommandWidget && item.writable) {
            <span class="command-badge badge badge-pill badge-info" translate>writable</span>
          }
        </div>
      </div>
    </ng-template>
  </ng-select>
</div>
